import styled, { css } from 'styled-components'
import { Media, mbSize } from '../../theme'

export const FlexWrap = styled.div`
  display: flex;
  line-height: 1.5;
  align-items: center;
  justify-content: space-around;
  max-width: unset;
  font-size: 14px;
  line-height: 20px;
  padding: 30px 120px 30px 60px;
  ${Media.lessThan(Media.small)} {
    flex-direction: column;
    align-items: center;
    padding: ${mbSize(32)} ${mbSize(32)} ${mbSize(40)};
    font-size: ${mbSize(20)};
    line-height: ${mbSize(28)};
  }
`

export const Container = styled.div`
  color: white;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`

export const ButtonWrap = styled.div`
  display: flex;
  margin-left: 100px;
  ${Media.lessThan(Media.small)} {
    margin: ${mbSize(16)} 0 0;
  }
`

export const PolicyLink = styled.a`
  text-decoration: underline;
  color: #ffffff;
`

const buttonCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 30px;
  border-radius: 15px;
`

export const DeclineButton = styled.button`
  ${buttonCss}
  border: 1px solid #fb6b4a;
  background: transparent;
  color: #fb6b4a;
  margin-right: 30px;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(32)};
    margin-right: ${mbSize(70)};
    width: ${mbSize(240)};
    height: ${mbSize(60)};
  }
`

export const AcceptButton = styled.button`
  ${buttonCss}
  background: #E8482B;
  color: #fff;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(32)};
    width: ${mbSize(240)};
    height: ${mbSize(60)};
  }
`
